module.exports = __webpack_public_path__ + "img/yixiaoxing1.23a7dca7.png";